module.exports = __webpack_public_path__ + "static/ns-logo-block-ebbc8dbe37e32ad61edafb140f00519e.svg";